module.exports = __webpack_public_path__ + "media/images/sp-about-head@2x-b8c66d4f3ff8212903084b81ce567cf9.png";